import { css } from 'styled-components';

import SourceSansProBold from './en/SourceSansProBold.woff2';
import SourceSansProItalic from './en/SourceSansProItalic.woff2';
import SourceSansProLight from './en/SourceSansProLight.woff2';
import SourceSansProRegular from './en/SourceSansProRegular.woff2';
import SourceSansProSemiBold from './en/SourceSansProSemiBold.woff2';
import SourceSansProExtraLight from './en/SourceSansProExtraLight.woff2';

export default css`
  /* en */
  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 200;
    src:
      local('Source Sans Pro ExtraLight'),
      local('SourceSansPro-ExtraLight'),
      url(${SourceSansProExtraLight}) format('woff2');
  }

  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 300;
    src:
      local('Source Sans Pro Light'),
      local('SourceSansPro-Light'),
      url(${SourceSansProLight}) format('woff2');
  }

  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 400;
    src:
      local('Source Sans Pro'),
      local('SourceSansPro-Regular'),
      url(${SourceSansProRegular}) format('woff2');
  }

  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 600;
    src:
      local('Source Sans Pro SemiBold'),
      local('SourceSansPro-SemiBold'),
      url(${SourceSansProSemiBold}) format('woff2');
  }

  @font-face {
    font-family: Main;
    font-style: normal;
    font-weight: 700;
    src:
      local('Source Sans Pro Bold'),
      local('SourceSansPro-Bold'),
      url(${SourceSansProBold}) format('woff2');
  }

  @font-face {
    font-family: Main;
    font-style: italic;
    font-weight: 400;
    src:
      local('Source Sans Pro Italic'),
      local('SourceSansPro-It'),
      url(${SourceSansProItalic}) format('woff2');
  }
`;
